import React from 'react';
import { Typography } from '../../style/Typography';
import styled from 'styled-components';
import SEO from '../seo';
import Img from 'gatsby-image';
import { Share } from '../share/Share';

const Hero = styled(Img)`
  height: 500px;
  margin-bottom: 20px;
  background: linear-gradient(
    to bottom,
    rgba(245, 246, 252, 0.52),
    rgba(117, 19, 93, 0.73)
  );

  /* full width image bleed fix, it's magic don't touch */
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  @media only screen and (max-width: ${props =>
      props.theme.breakpoints.medium}) {
    height: 35vh;
  }

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      0deg,
      rgba(17, 19, 31, 1) 0%,
      rgba(17, 19, 31, 1) 2%,
      rgba(17, 19, 31, 0) 50%
    );
    z-index: 1;
  }
`;

const TextWrapper = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 20px;

  h1,
  h2,
  h3,
  h4,
  p {
    margin: 10px 0;
  }
`;

export function PatchNotePage({ data }) {
  const getPageURL = () => {
    // we static now
    const url = typeof window !== 'undefined' ? window.location.origin : '';
    const formattedURL = data?.patchNumber.replace(/\./g, '-');
    return url + '/patch-note/' + formattedURL;
  };

  return (
    <>
      <SEO
        title={`Patch note ${data?.patchNumber}`}
        description={data?.patchNotes?.patchNotes}
      />
      <Hero fluid={data?.image?.fluid} />
      <TextWrapper>
        <Typography variant="bodyLarge" color="brand">
          {data?.patchDate}
        </Typography>
        <Typography variant="h1">Version: {data?.patchNumber}</Typography>
        <Typography
          variant="bodyLarge"
          dangerouslySetInnerHTML={{
            __html: data?.patchNotes?.childMarkdownRemark?.html,
          }}
        />
        <Share textToCopy={getPageURL()} toastText="Copied!" />
      </TextWrapper>
    </>
  );
}
